import markDeclares from "./markDeclares";
import markDeclareReturn from "./markDeclareReturn";

const markDeclareService = [{
    matcher: 'cropMarkDeclare',
    reply: config => {
        return [200, markDeclares]
    }
},{
    matcher: /cropMarkDeclare\/(.*)/,
    reply: config => {
        const id = /cropMarkDeclare\/(.*)/.exec(config.url)[1];
        const data = markDeclares.find(app => app.id === id);
        return [200, data];
    }
},{
    matcher: 'cropMarkDeclareReturn',
    reply: config => {
        return [200, markDeclareReturn];
    }
},{
    matcher: /cropMarkDeclareReturn\/(.*)/,
    reply: config => {
        const id = /cropMarkDeclareReturn\/(.*)/.exec(config.url)[1];
        const data = markDeclareReturn.find(app => app.id === id);
        return [200, data];
    }
}]

export default markDeclareService